import React, {
  useEffect,
  useState
} from 'react'
import {
  Dropdown,
  Responsive
} from 'semantic-ui-react'
import orderBy from 'lodash/orderBy'
import filter from 'lodash/filter'
// Local
import { API_URL } from '../../constant'
import { api } from '../../action/api'
import { searchGenerator } from '../../action/search'

type NameAndValue = {
  name: string
  value: string
}

type Props = any

function OrganizationSelect(
  props: Props
): JSX.Element {
  const {
    allOption: hasAllOption,
    multiple: hasMultiple,
    name: nameProp,
    onChange: onChangeProp,
    placeholder: placeholderProp,
    value: valueProp
  } = props

  const [
    organizationsState,
    setOrganizationsState
  ] = useState<any[]>([])

  const hasMultipleState = hasMultiple !== false

  const hasAllOptionState = hasAllOption !== false

  useEffect(() => {
    let mounted = true
    const url = API_URL.GET_ORGANIZATIONS
    const params = searchGenerator(null, 999, 0, 'name asc', undefined)
    api.get(url, { params }).then(({ data }) => {
      if (!mounted) return
      setOrganizationsState(orderBy(filter(data, e => e.active === true), 'name', 'asc'))
    })
    return () => { mounted = false }
  }, [])

  const onChange = (
    e: any,
    { value }: NameAndValue
  ) => {
    if (onChangeProp) {
      onChangeProp(
        e,
        {
          name: nameProp || 'organizationSelect',
          value: value === 'ALL'
            ? null
            : value
        }
      )
    }
  }

  const options = organizationsState.map(org => ({
    key: org.id,
    value: org.id,
    text: org.name
  }))

  if (hasAllOptionState === true) {
    options.unshift({
      key: 'ALL',
      text: 'All',
      value: 'ALL'
    })
  }

  const placeholder = placeholderProp || 'Organizations'

  if (hasMultipleState === true) {
    const value = valueProp || []
    return (
      <Responsive
        as={ Dropdown }
        fluid multiple selection
        placeholder={ placeholder }
        onChange={ onChange }
        options={ options }
        value={ value } />
    )
  }

  return (
    <Responsive
      as={ Dropdown }
      fluid selection
      placeholder={ placeholder }
      onChange={ onChange }
      options={ options }
      value={ valueProp || undefined } />
  )
}

export default OrganizationSelect
